export const MESSAGE_DIALOG_TYPE_ERROR = 'MESSAGE_DIALOG_TYPE_ERROR';
export const MESSAGE_DIALOG_TYPE_INFO = 'MESSAGE_DIALOG_TYPE_INFO';
export const MESSAGE_DIALOG_TYPE_INFO_INTL = 'MESSAGE_DIALOG_TYPE_INFO_INTL';
export const MESSAGE_DIALOG_TYPE_ERROR_INTL = 'MESSAGE_DIALOG_TYPE_ERROR_INTL';
export const MESSAGE_DIALOG_TYPE_DISCLAIMER = 'MESSAGE_DIALOG_TYPE_DISCLAIMER';



// WEBPACK FOOTER //
// ./src/js/constants/messageDialogTypes.js